import { IBaseBenefitTemplate, IBenefitTemplate } from 'types/income';
import { converters as tableConverters } from 'store/table';
import {
  BaseBenefitTemplate,
  BenefitTemplate,
  convertBaseBenefitTemplate,
  convertBenefitTemplate,
} from 'store/benefit-templates';
import { loaders } from './admin-benefit-templates.loaders';

const convertAdminBaseBenefitTemplate = (
  template: IBaseBenefitTemplate,
): BaseBenefitTemplate => {
  return {
    ...convertBaseBenefitTemplate(template),
  };
};

const convertAdminBenefitTemplate = (
  template: IBenefitTemplate,
): BenefitTemplate => {
  return {
    ...convertBenefitTemplate(template),
  };
};

const convertAdminBenefitTemplates = (
  templates: IBaseBenefitTemplate[],
): BaseBenefitTemplate[] => {
  return templates.map(convertAdminBaseBenefitTemplate);
};

export const converters = {
  getBenefitTemplates: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getBenefitTemplates>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertAdminBenefitTemplates(data.data),
      total,
      page,
      pageSize,
      pages,
    };
  },
  getBenefitTemplate: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getBenefitTemplate>>) => {
    return convertAdminBenefitTemplate(data);
  },
};
